import axiosRetry from 'axios-retry';
import axios, { AxiosError, AxiosResponse } from 'axios';

import { HttpTypes } from './types.http';
import { AxiosConnectionError } from './errors';
import { setAxiosAuthorization } from './axios-authorization-header';
import { useAuthStore } from 'src/auth/auth.store';
import { FILE_API } from 'src/config-global';

export const api = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const apiRetry = axios.create({
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: FILE_API,
});

axiosRetry(api, { retries: 3 });

function resetSession(): void {
  auth.clearSession();
  window.location.replace('/login');
}

const auth = useAuthStore.getState();

export class AxiosHttpClient implements HttpTypes.HttpClient {
  private readonly url: string = '';

  constructor(
    private readonly baseURL: string,
    private readonly interceptors?: any
  ) {
    // setAxiosAuthorization(api, 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY3NjcyZmFkMzc0MTM4MzAxNjJjMTI0ZCIsImRhdGEiOnsiX2lkIjoiNjc2NzJmYWQzNzQxMzgzMDE2MmMxMjRkIiwibmFtZSI6IlRlc3RlIFF1YWxxdWVyIiwiZW1haWwiOiJsdWNhc0BnbWFpbC5jb20ifSwiYWNjZXNzIjpbImNuX2FkbWluIl0sImlhdCI6MTczNDg4OTA3OCwiZXhwIjo0ODkwNjQ5MDc4fQ.6lHzUXus_xQnHqWLLPcZJpJhhmRlz7Mu0uHXcXyKlHY')
    setAxiosAuthorization(api, auth.accessToken || '');
    // if (auth.accessToken && api.defaults.headers.Authorization === undefined) {
    //   setAxiosAuthorization(api, auth.accessToken);
    // }

    if (this.baseURL) {
      this.url = this.baseURL;
    }

    if (interceptors) {
      this.interceptors?.forEach((interceptor: ['request' | 'response', ...any[]]) => {
        const [type, ...args] = interceptor;
        api.interceptors[type].use(...args);
      });
    }
  }

  async getTokens(refreshTokenParam?: string): Promise<void> {
    const data: HttpTypes.HttpRequest = {
      url: '', // TODO: PEGAR A URL DO BACK
      method: 'get',
      headers: {
        authorization: `Bearer ${refreshTokenParam}`,
        'Content-Type': 'application/json',
      },
    };
    const response = await this.request(data);
    const { accessToken, refreshToken } = response.body as any;
    if (accessToken && refreshToken) {
      auth.setSession(accessToken, refreshToken); // TODO: Verificar o objeto que é retornado do back pra passar certo o valor
      setAxiosAuthorization(api, accessToken);
    } else {
      auth.clearSession();
    }
  }

  static resetSession(): void {
    auth.clearSession();
    window.location.replace('/login');
  }

  async request(
    data: HttpTypes.HttpRequest,
    retryToGetTokens: boolean = true
  ): Promise<HttpTypes.HttpResponse> {
    let axiosResponse: AxiosResponse;
    const headers = {
      ...data.headers,
    };
    if (!data.url.includes('login')) {
      headers.Authorization = `Bearer ${localStorage.getItem('accessToken') || useAuthStore.getState().accessToken}`;
    }
    try {
      axiosResponse = await api.request({
        url: data.url ? `${this.url}/${data.url}` : this.url,
        method: data.method,
        data: data.body,
        params: data.params,
        responseType: data.responseType,
        headers: {
          ...headers,
        },
      });
    } catch (error: any) {
      const errors = error as AxiosError;
      if (error?.response?.status === 401) {
        if (retryToGetTokens) {
          try {
            const response = await apiRetry.get('/auth/cn-admin/new-token', {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('refresh') || auth.refreshToken}`,
              },
            });

            const { accessToken, refreshToken } = response.data;
            auth.setSession(accessToken, refreshToken);
            setAxiosAuthorization(api, accessToken);
            localStorage.setItem('refresh', refreshToken);
            localStorage.setItem('accessToken', accessToken);
            return await this.request(data, false);
          } catch {
            resetSession();
          }
        } else {
          resetSession();
        }
      }

      if (errors.response) {
        axiosResponse = errors?.response;
      } else if (errors.request) {
        axiosResponse = errors?.request;
      } else {
        axiosResponse = AxiosConnectionError as AxiosResponse;
      }
    }
    return {
      statusCode: axiosResponse.status,
      body: axiosResponse.data,
    };
  }

  // eslint-disable-next-line class-methods-use-this
  async fakeRequest(
    data: HttpTypes.HttpRequest,
    options: HttpTypes.RequestOptions
  ): Promise<HttpTypes.HttpResponse> {
    const fakeResponse: HttpTypes.HttpResponse = {
      body: options.data,
      statusCode: options.status,
    };

    if (options.delay) {
      await new Promise((resolve) => setTimeout(resolve, options.delay));
    }

    return Promise.resolve(fakeResponse);
  }
}
